// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_pnpm_emotion_hash_0_8_0_node_modules_emotion_hash_dist_hash_browser_esm_-2f2eb5":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}